import React, { FunctionComponent, useEffect, useState } from "react";
import { RouteProps } from "../../../types/route";
import { handleGetUser } from "../../../services/auth";
import { navigate } from "gatsby";
import Loading from "../loading";

const Route: FunctionComponent<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    const f = async () => {
      const res = await handleGetUser(signal);
      if (res.result === "success" && location.pathname === `/`) {
        navigate("/app/");
        return;
      }
      setLoading(false);

      return function cleanup() {
        abortController.abort();
      };
    };

    f();
  }, []);

  if (loading) {
    return <Loading />;
  } else {
    return <Component {...rest} />;
  }
};

export default Route;
